export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 10_06.7ac55bc9.jpg";